export const layout = {
  page: {
    maxWidth: {
      narrow: 900,
      content: 1200,
      wide: 1440,
    },
    paddingX: { xs: 2.5, md: 3.5 },
    paddingY: { xs: 3.5, md: 4.5 },
  },

  pageHeader: {
    titleBottomGap: 0.75,
    contentBottomGap: 3,
    actionsGap: 1,
  },

  sidebar: {
    itemHeight: 44,
    itemRadius: 1.5,
    itemInsetX: 1.25,
    itemGapY: 0.25,
    iconMinWidth: 32,
    sectionHeaderPx: 3,
    sectionGapY: 1.25,
    contentPaddingTop: 1,
    contentPaddingBottom: 1,

    brandHeight: 60,
    brandIconSize: 32,
    brandCollapsedIconSize: 34,
    brandTopGap: 1.25,
    brandBottomGap: 1,
  },

  edit: {
    formWidth: 920,
    asideWidth: 320,
    gap: 3,
  },

  show: {
    contentWidth: 920,
    asideWidth: 320,
    gap: 3,
  },

  list: {
    gap: 3,
    filtersPaddingX: 2.5,
    filtersPaddingY: 1,
    actionsGap: 1,
    searchWidth: 360,
    searchMaxWidth: 420,
    filterMinWidth: 220,
    tableMinWidth: 900,
    headerHeight: 52,
    dateWidth: 170,
  },

  form: {
    legalLabelPaddingTop: 0.5,
    contentWidth: 640,
    sectionGap: 3,
    fieldGap: 2,
  },

  section: {
    gap: 3,
  },

  card: {
    radius: 2,
    padding: 3,
    variant: "outlined",
    elevation: 0,
  },

  status: {
    chipHeight: 24,
  },
} as const;

export type AppPageWidth = keyof typeof layout.page.maxWidth;
